/** Cor de destaque do fluxo Boticário (UI). */
export const BRAND_COLOR_BOTICARIO = '#06a472';

/** Cor de destaque do fluxo Eudora (Figma). */
export const BRAND_COLOR_EUDORA = '#613A53';

export function brandAccentColor(brand) {
  return brand === 'eudora' ? BRAND_COLOR_EUDORA : BRAND_COLOR_BOTICARIO;
}
